import _defineProperty from '@babel/runtime/helpers/defineProperty';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var colViewWidth = {
  s: 4,
  m: 12,
  l: 12,
  xl: 12
};
var colWidthToken = {
  s: {
    s: 4,
    m: 5,
    l: 4,
    xl: 4
  },
  m: {
    s: 4,
    m: 7,
    l: 6,
    xl: 6
  },
  l: {
    s: 4,
    m: 10,
    l: 8,
    xl: 8
  }
};
var marginYToken = {
  s: '48',
  m: '64',
  l: '64',
  xl: '64'
};

/** Subtract 2 times for the spacing between the modal and the edge of the screen for 2 sides */
var transformToViewWidth = function transformToViewWidth(size, screenSize, spacing) {
  return "calc(100vw * ".concat(colWidthToken[size][screenSize], " / ").concat(colViewWidth[screenSize], " - ").concat(spacing, " - ").concat(spacing, ")");
};
var transformToViewHeight = function transformToViewHeight(spacing) {
  return "calc(100vh - ".concat(spacing, " - ").concat(spacing, ")");
};
var modalSizeMapper = function modalSizeMapper(size, screenSize, widthSpacing, heightSpacing) {
  return {
    width: transformToViewWidth(size, screenSize, widthSpacing),
    maxHeight: transformToViewHeight(heightSpacing),
    my: marginYToken[screenSize]
  };
};
var actionPropsMapper = function actionPropsMapper(size, screenSize) {
  var direction = size === 's' || screenSize === 's' ? 'column' : 'row';
  return {
    direction: direction,
    flexDirection: direction === 'column' ? 'column' : 'row',
    alignItems: direction !== 'column' ? 'baseline' : undefined
  };
};
var closeButtonPropsMapper = function closeButtonPropsMapper(heroAsset, onClick, closeButton) {
  var _closeButton$ariaLab;
  return _objectSpread(_objectSpread({}, closeButton), {}, {
    hierarchy: heroAsset ? 'secondary' : 'tertiary',
    variant: 'icon',
    size: 'm',
    'aria-label': (_closeButton$ariaLab = closeButton === null || closeButton === void 0 ? void 0 : closeButton['aria-label']) !== null && _closeButton$ariaLab !== void 0 ? _closeButton$ariaLab : 'close',
    me: '12',
    mt: '12',
    onClick: onClick
  });
};

export { actionPropsMapper, closeButtonPropsMapper, modalSizeMapper };
//# sourceMappingURL=Modal.mappers.js.map
